var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tab-navigation" },
    _vm._l(_vm.tabs, function (tab) {
      return _c("TabButton", {
        key: tab.id,
        attrs: {
          label: tab.label,
          "icon-src": tab.iconSrc,
          "icon-alt": tab.iconAlt,
          "is-active": _vm.activeTab === tab.id,
        },
        on: {
          click: function ($event) {
            return _vm.handleTabClick(tab.id)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }